// extracted by mini-css-extract-plugin
export default {"creditDataBox":"ItemContainer_creditDataBox__njHl8","title":"ItemContainer_title__N2yEA","list":"ItemContainer_list__8kVGj"};